import React, { useState, useMemo } from "react";
import _ from "lodash";
import { Grid, Card, Progress, Accordion, Icon, Header, Button } from "semantic-ui-react";

export default function WeeksTimeline({ data = {} }) {

  // const dataStructure = {
  //   2024: {
  //     week1: 2,
  //     week2: 35
  //   },
  //   2025: {
  //     week1: 321,
  //     week2: 323
  //   }
  // }

  const getWeekStartDate = (year, week, startOnMonday = true) => {
    const simple = new Date(year, 0, 1 + (week - 1) * 7);
    const dow = simple.getDay(); // 0=Sun, 1=Mon, etc
    const ISOweekStart = new Date(simple);
    const adjust = startOnMonday ? (dow <= 1 ? dow - 1 : dow - 8) : -dow;
    ISOweekStart.setDate(simple.getDate() - adjust);
    return ISOweekStart.toDateString(); // e.g. "Mon Jan 08 2024"
  };

  const years = useMemo(() => {
    return _(data)
      .toPairs() // [[year, {week1:9,...}], ...]
      .map(([year, weeks]) => ({
        year: Number(year),
        weeks: _(weeks)
          .toPairs() // [["week1", 9], ...]
          .map(([key, value]) => ({
            week: Number(key.replace("week", "")),
            value,
          }))
          .sortBy("week") // <-- ensure sorted by week number
          .value(),
      }))
      .sortBy("year")
      .value();
  }, [data]);

  console.log('data', data)

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => setActiveIndex((prev) => (prev === index ? null : index));

  let _total = 0

  return (
    <div style={{ padding: 20 }} className="app-dark-mode">
      <Header as="h2" dividing>
        Weekly Overview
      </Header>

      <Accordion fluid styled>
        {years.map(({ year, weeks }, yearIdx) => {

          const avg = _.meanBy(weeks, "value") || 0;
          const maxVal = _.maxBy(weeks, "value")?.value || 0;
          const total = _.sumBy(weeks, "value") || 0;

          return (
            <React.Fragment key={year}>
              <Accordion.Title
                active={activeIndex === yearIdx}
                index={yearIdx}
                onClick={() => toggleAccordion(yearIdx)}
              >
                <Icon name="dropdown" />
                {year} &nbsp; • &nbsp; {weeks.length} weeks &nbsp; • &nbsp; Avg:{" "}
                {Math.round(avg)} &nbsp; • &nbsp; Max: {maxVal} • &nbsp; Total: {total}
              </Accordion.Title>

              <Accordion.Content active={activeIndex === yearIdx}>
                <Grid stackable doubling columns={7}>
                  {weeks.map(({ week, value }) => {
                    _total += value
                    return < Grid.Column key={week} style={{ padding: '.25em' }}>
                      <Card fluid>
                        <Card.Content>
                          <Card.Header>Week {week}</Card.Header>
                          <Card.Meta style={{ padding: '.25em' }}>Date: {getWeekStartDate(year, week, true)}</Card.Meta>
                          <Card.Meta style={{ padding: '.25em' }}>Value: {value}</Card.Meta>
                          <Progress
                            style={{ padding: '.25em', margin: '.25em 0' }}
                            percent={Math.min(value, 100)}
                            progress
                            indicating
                          />
                          <Card.Meta style={{ padding: '.25em' }}>Total: {_total}</Card.Meta>
                        </Card.Content>
                      </Card>
                    </Grid.Column>
                  })}
                </Grid>
              </Accordion.Content>
            </React.Fragment>
          );
        })}
      </Accordion>
    </div >
  );
}
